module.exports = __webpack_public_path__ + "img/Setting.bef31635.svg";